enum TaskDeliverableType {
    BLANK = 'blank',
    FILE = 'file',
    TEXT = 'text',
    EMBED = 'embed',
}

export default TaskDeliverableType;
